// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1_82X","footer":"ModalInfo_footer__2N1ED"};